export default __webpack_public_path__ + "static/media/half_heart.3e101bd8.png";